import React, { useEffect, useMemo } from "react";
import { convertToHtml, generateRandomString } from "../../../utils/commonFunctions";

import AI from '../../../assets/icons/icon_ai.png';
import Spraking from '../../../assets/icons/icon_speak.gif';
import { Tooltip } from "react-tooltip";

/**
 * 
 * @param {대화이력, 통신상태} param0 
 * @returns 
 */
const Interview = ({ history, fetching }) => {

  const memoizedHistory = useMemo(() => history, [history])

  useEffect(() => {
    if (history.length === 0) return
  }, [history])

  return (
    memoizedHistory?.map((item, idx) => {
      return (
        <div className="chat-ls" key={generateRandomString(idx)}>
          {
            (item?.input_text && item?.input_text !== '' && item?.input_text !== null && item?.input_text !== '...' && item?.input_text !== 'None') &&
            <div className="flx-box ans-wrp">
              <div className="interview-ans flx-box">
                <p className="chat-ques__txt">{item?.input_text}</p>
              </div>
            </div>
          }
          <div className="interview-wrp flx-box" style={!item?.answer ? { display: 'none' } : null}>
            <div className="interview-wrp__lg" >
              <img src={AI} alt="donga-icon"/>
            </div>
            <div className="interview-wrp__bg" >

              {
                // clario 일반  답변
                item?.answer && (item?.action === "DSocrates" || item?.action === "chat")
                  ?
                  (
                    <div className="interview-wrp__txt" >
                      {typeof (item?.answer) === 'string'
                        ?
                        convertToHtml(item?.answer)
                        :
                        item?.answer
                      }
                      <div className="interview-wrp__refs flx-box" style={Array.isArray(item?.reference) ? null : { display: 'none' }}>
                        {
                          Array.isArray(item?.reference) && item?.reference.length !== 0
                          &&
                          <div className="ref-title">참고자료</div>
                        }
                        {
                          Array.isArray(item?.reference) && item?.reference?.map((sItem, sIdx) => {
                            return (
                              <div className="ref-item__wrp">
                                <Tooltip className="tooltip" id={`ref-item-${sIdx}`} place="top" offset={20} style={{ background: '#4b4da0', padding: '1px 5px' }} />
                                <a
                                  id={sIdx}
                                  data-tooltip-id={`ref-item-${sIdx}`}
                                  data-tooltip-content={sItem.name}
                                >
                                  <div key={generateRandomString(sIdx)} className="ref-list crs-btn">
                                    {/* {sIdx === 0 ? '참고자료:  ' : ''} */}
                                    <a href={sItem.url} target="_blank" rel="noreferrer">
                                      {`${sIdx + 1}. ${sItem.name}`}
                                    </a>
                                  </div>
                                </a>
                              </div>
                            )
                          })
                        }

                      </div>

                    </div>
                  )
                  : item?.action === 'error'
                    ?
                    <div className="interview-wrp__txt" >질문을 바꿔서 다시 시도해주세요.</div>
                    :
                    null
              }

            </div>


          </div>

          {
            (fetching && idx === memoizedHistory.length - 1 && (memoizedHistory[memoizedHistory.length - 1].answer === ''))
            &&
            <div className="flx-box socrates-loading" >
              <img src={Spraking} />
              <p>질문을 생각하고 있어요.</p>
            </div>
          }
        </div>

      )
    })
  )
}
export default Interview;